export const emailRegex =
    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const phoneRegex = /^\+[\d]+[.][\d]+$/;

export const passwordRegex =
    /^(?=.*[\d])(?=.*[a-z])(?=.*[A-Z])(?=.*[`!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>/?~])[\w`!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>/?~]{8,}$/;
